import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';

import { CommonModule } from '@angular/common';

import {
  ApiFieldValidationErrors,
  ApiValidationError
} from '../../models/api-validation.model';

@Component({
  selector: 'app-api-validation-message',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl:
    './api-validation-message.component.html',
  styleUrls: [
    './api-validation-message.component.scss'
  ]
})
export class ApiValidationMessageComponent
  implements OnChanges {

  @Input()
  error: ApiValidationError | string | null = null;

  @Input()
  title = 'Unable to complete request';

  @Input()
  dismissible = true;

  @Output()
  dismissed = new EventEmitter<void>();

  private manuallyDismissed = false;

  ngOnChanges(
    changes: SimpleChanges
  ): void {

    if (changes['error']) {
      this.manuallyDismissed = false;
    }
  }

  get showValidationMessage(): boolean {
    return (
      !this.manuallyDismissed &&
      !!this.error &&
      (
        !!this.mainMessage ||
        this.validationMessages.length > 0
      )
    );
  }

  get mainMessage(): string {
    if (!this.error) {
      return '';
    }

    if (typeof this.error === 'string') {
      return this.error;
    }

    return this.error.message || '';
  }

  get validationMessages(): string[] {
    if (
      !this.error ||
      typeof this.error === 'string' ||
      !this.error.errors
    ) {
      return [];
    }

    if (Array.isArray(this.error.errors)) {
      return this.error.errors
        .filter(message => !!message)
        .map(message => String(message));
    }

    return this.convertFieldErrorsToMessages(
      this.error.errors
    );
  }

  closeMessage(): void {
    this.manuallyDismissed = true;
    this.dismissed.emit();
  }

  private convertFieldErrorsToMessages(
    errors: ApiFieldValidationErrors
  ): string[] {

    const messages: string[] = [];

    Object.entries(errors).forEach(
      ([fieldName, fieldErrors]) => {

        const formattedFieldName =
          this.formatFieldName(fieldName);

        if (Array.isArray(fieldErrors)) {
          fieldErrors.forEach(errorMessage => {
            if (errorMessage) {
              messages.push(
                `${formattedFieldName}: ${errorMessage}`
              );
            }
          });

          return;
        }

        if (fieldErrors) {
          messages.push(
            `${formattedFieldName}: ${fieldErrors}`
          );
        }
      }
    );

    return messages;
  }

  private formatFieldName(
    fieldName: string
  ): string {

    const formattedName = fieldName
      .replace(/([A-Z])/g, ' $1')
      .replace(/[_-]/g, ' ')
      .trim();

    return (
      formattedName.charAt(0).toUpperCase() +
      formattedName.slice(1)
    );
  }
}